import { ApiBaselegacy } from "../base/api-baselegacy";

export class UserService extends ApiBaselegacy {

    async getProfileUID(uid) {
        return await this.get(`persona/ObtenerPersonaUid?uid=${uid}`);
    }

    async socialNetworkLogIn(person) {
        return await this.post(`persona/AgregarPersonaRedes`, person);
    }

    async addPerson(person) {
    return this.post(`persona/AgregarPersona`, person); 
    }



   
    async updatePerson(person) {
        console.log("Datos enviados a UpdatePerson:", person);
        return await this.post(`persona/UpdatePerson`, person);
    }

  
    async logIn(request) {
        const response = await this.post(`login`, request);
        return response; // NO hagas .json() ni verifiques status aquí
    }


    ///////////////////H/////////////////
    async getProfileEmail({ email, password }) {
        return await this.post(`persona/ObtenerPersonaEmail`, { email, password });
    }

    async recoveryPassword(email) {
        return await this.post(`login/RecoveryPassword`, email);
    }

    async changePassword(request) {
        return await this.post(`persona/UpdatePassword`, request);
    }
    async addAddress(address) {
        return await this.post(`DireccionPersona/AgregarDireccionPersona`, address);
    }
    async listAddress(id) {
        return await this.get(`DireccionPersona/DireccionesAsociadas?id=${id}`);
    }
    async deleteAddress(id) {
        return await this.post(`direccionPersona/EliminarDireccionPersona?id=${id}`);
    }
    async sendComment(comment) {
        return await this.post(`Tienda/InsertarMensajesTienda`, comment);
    }
    async getOrders(id) {
        return await this.get(`orden/${id}`);
    }
    async addOrder(request) {
        console.log("imprimir valores Reguest", request);
        return await this.post(`orden/CrearOrden`, request);
    }
    async getCiudades(dept) {
        return await this.get(`ciudades/GetCiudadesxDep?dept=${dept}`);
    }
    async getIdentificationType() {
        return await this.get("Domain/ObtenerTiposDocCuenta");
    }
    async psePayment(request) {
        return await this.post(`pago/PagarConPse`, request);
    }
    async cashPayment(idOrden, ipOrigen) {
    return await this.post(`pago/PagoEnEfectivo?IdOrden=${idOrden}&IpOrigen=${ipOrigen}`);
}
    async creditCardPayment(request) {
        return await this.post(`pago/PagarConTarjeta`, request);
    }


}
